<div class="bg-white rounded-lg border border-gray-200 flex-1">
  <a
    [routerLink]="entry().route"
    class="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors cursor-pointer">
    <div class="flex items-center gap-4">
      <div class="shrink-0">
        <svg class="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            [attr.stroke-width]="entry().iconStrokeWidth ?? 2"
            [attr.d]="entry().iconPath" />
        </svg>
      </div>
      <div class="flex flex-col">
        <span class="text-base font-medium text-gray-900">{{ entry().titleKey | translate }}</span>
        <span class="text-sm text-gray-500">{{ entry().subtitleKey | translate }}</span>
      </div>
    </div>
    <div class="shrink-0">
      <svg class="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
    </div>
  </a>
</div>
